export const GET_PRODUCT_LIST_REQUEST = '@product/GET_PRODUCT_LIST_REQUEST';
export const GET_PRODUCT_LIST_SUCCESS = '@product/GET_PRODUCT_LIST_SUCCESS'
export const GET_PRODUCT_LIST_FAILURE = '@product/GET_PRODUCT_LIST_FAILURE'